var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: { height: "355px", "max-height": "500px", overflow: "auto" }
    },
    [
      _c(
        "v-row",
        { attrs: { justify: "end", align: "center" } },
        [
          _c("v-checkbox", {
            attrs: {
              label: _vm.$t("OnlyUsedElements"),
              disabled: _vm.disabledView,
              color: "accent"
            },
            model: {
              value: _vm.usedElements,
              callback: function($$v) {
                _vm.usedElements = $$v
              },
              expression: "usedElements"
            }
          }),
          _vm._v(" "),
          _c(
            "v-col",
            {
              directives: [
                {
                  name: "on-clickaway",
                  rawName: "v-on-clickaway",
                  value: _vm.closeSearch,
                  expression: "closeSearch"
                }
              ],
              staticStyle: { "z-index": "3" },
              attrs: { cols: "8", sm: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "menu",
                attrs: {
                  rounded: "",
                  dense: "",
                  height: "32",
                  solo: "",
                  placeholder: _vm.$tc("AddActivity"),
                  disabled: _vm.disabledView,
                  "append-icon": "arrow_drop_down"
                },
                on: {
                  click: function($event) {
                    _vm.menu = !_vm.menu
                  }
                },
                model: {
                  value: _vm.searchTemplate,
                  callback: function($$v) {
                    _vm.searchTemplate = $$v
                  },
                  expression: "searchTemplate"
                }
              }),
              _vm._v(" "),
              _vm.menu
                ? _c("div", { staticClass: "menu-position-templates" }, [
                    _vm.filterTemplates.length > 0
                      ? _c(
                          "ul",
                          _vm._l(_vm.filterTemplates, function(templates) {
                            return _c(
                              "li",
                              {
                                key: templates.uuid,
                                on: {
                                  click: function($event) {
                                    return _vm.selectTemplate(templates)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(templates.title) +
                                    "\n          "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _c("ul", [_c("li", [_vm._v("No Data Available")])])
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mt-9 pl-0" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-center flex-column" },
          _vm._l(_vm.selectedTemplatesFor, function(template, i) {
            return _c(
              "v-col",
              { key: i, staticClass: "d-flex justify-start mb-5 pl-0" },
              [
                _vm.receivedData.activities.find(function(item) {
                  return item.title === template.title
                })
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex align-start justify-start pr-2",
                        staticStyle: { width: "36px" }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "rotate-button",
                                attrs: { tile: "", icon: "", small: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteTemplate(template)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("delete")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "rotate-text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(template.title) +
                                  "\n            "
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "left-side d-flex flex-column" },
                  _vm._l(_vm.receivedData.activities, function(activity) {
                    return _c(
                      "div",
                      { key: activity.uuid },
                      [
                        activity.title === template.title
                          ? _c(
                              "v-card",
                              {
                                staticClass: "d-flex align-center",
                                staticStyle: {
                                  "margin-bottom": "40px",
                                  "margin-left": "20px"
                                },
                                attrs: {
                                  "min-width": "585px",
                                  width: "585px",
                                  height: "80px",
                                  elevation: "0"
                                }
                              },
                              [
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass: "card-title",
                                    attrs: {
                                      width: "220",
                                      height: "30",
                                      rounded: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-truncate" },
                                      [
                                        activity.object && activity.object.label
                                          ? _c(
                                              "span",
                                              {
                                                attrs: {
                                                  title: activity.object.label
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      activity.object.label
                                                    )
                                                )
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                attrs: {
                                                  title: activity.object_uuid
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getObjectTypeLabel(
                                                        activity.object_type
                                                      )
                                                    ) +
                                                    " UUID -\n                    " +
                                                    _vm._s(activity.object_uuid)
                                                )
                                              ]
                                            )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.disabledView &&
                                _vm.checkActivityOrTaskState(activity.state)
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "activity-delete-button",
                                        attrs: {
                                          icon: "",
                                          size: "20",
                                          disabled: _vm.disabledView
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.openActivityDialog(
                                              activity
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("delete")
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(activity.tasks, function(task) {
                                  return _c(
                                    "v-sheet",
                                    {
                                      key: task.uuid,
                                      staticClass:
                                        "ml-2 d-flex align-start justify-space-between",
                                      attrs: {
                                        color: "#E1E1E1",
                                        elevation: "0",
                                        height: "50",
                                        rounded: "",
                                        width: "130"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "task-text text-truncate",
                                          attrs: { title: task.title }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(task.title) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.disabledView &&
                                      _vm.checkActivityOrTaskState(task.state)
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                size: "20",
                                                disabled: _vm.disabledView
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.openTaskDialog(
                                                    activity,
                                                    task
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("delete")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            )
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c("SkeletonLoader", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.dialog,
          isPersistent: true,
          title: _vm.deleteTitle,
          content: _vm.$t(""),
          "main-action-label": _vm.$t("Yes"),
          "secondary-action-label": _vm.$t("No")
        },
        on: {
          mainAction: function($event) {
            return _vm.deleteActivityOrTask()
          },
          secondaryAction: _vm.closeDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b39ba0ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b39ba0ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/WorkOrderDetailTemplates.vue
// module id = null
// module chunks = 